import { displayTeamInviteUsername } from "../../utils/teamInviteDisplayUsername";
import type { AuthUser } from "../../types/authUser";

export type TeamLoginUser = {
  username: string;
  displayName: string;
  accessLevel: string;
  orgId: string;
  circleIds: string[];
  phoneNumber?: string;
  phoneVerified: boolean;
  tier?: string;
  sponsored?: boolean;
  featureFlags?: Record<string, boolean>;
  soid?: string;
};

export const transformTeamMemberToAdminStructure = (
  teamMemberData: TeamLoginUser
): AuthUser => {
  // Invite flow shows `local@soid` via displayTeamInviteUsername; keep this
  // aligned with that so the same account renders identically in both places.
  const emailForDisplay = displayTeamInviteUsername(
    String(teamMemberData.username || ""),
    teamMemberData.soid
  );

  return {
    // Team member specific data
    id: teamMemberData.username,
    username: teamMemberData.username,
    displayName: teamMemberData.displayName,
    accessLevel: teamMemberData.accessLevel,
    circleIds: teamMemberData.circleIds,
    phoneNumber: teamMemberData.phoneNumber,
    phoneVerified: teamMemberData.phoneVerified,
    featureFlags: teamMemberData.featureFlags || undefined,
    userType: "team" as const,

    // Transform to admin-compatible structure
    fullName: teamMemberData.displayName, // Use for avatar initials and welcome messages
    schoolId: teamMemberData.orgId,
    // Keep canonical org id (OID), not toPascalCase — that broke HILLARY-PRIMARY-SCHOOL → "Hillary-primary-school".
    orgId: teamMemberData.orgId,
    soid: teamMemberData.soid, // Include soid from backend response
    schoolName: teamMemberData.displayName, // Show team member name in UI contexts
    email: emailForDisplay,

    // Organization defaults (team members belong to approved orgs)
    isSchoolApproved: true,
    tier: teamMemberData.tier != null ? String(teamMemberData.tier) : "0",
    sponsored: teamMemberData.sponsored === true,
    isCircleOpen: false,
    schoolLogo: "",
    schoolDescription: "",
    schoolType: "Organization",
    createdAt: new Date().toISOString(),
    PK: `ORG#${teamMemberData.orgId}`,
    SK: `ORG#${teamMemberData.orgId}`,
  };
};
